import React, { ComponentPropsWithRef, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthModal } from '@auth/business/AuthModal.hook';
import { BasicLink } from '@components/buttons/BasicLink/BasicLink.component';
import { AppDispatch, RootState } from '@store/store';
import { ProfileTabEnum } from '@user/business/User.enums';
import { getTransversalLinkProps, urlEnum } from '@utils/url';

const QuickAccess: FC<ComponentPropsWithRef<'div'>> = (props) => {
  const {
    auth: { signOut },
  } = useDispatch<AppDispatch>();
  const { showSignInModal } = useAuthModal();
  const { isAuthenticated } = useSelector((state: RootState) => ({
    isAuthenticated: state.auth.isAuthenticated,
  }));

  return (
    <div {...props}>
      <div>
        <BasicLink
          as={isAuthenticated ? `${urlEnum.profile}/${ProfileTabEnum.profile}` : urlEnum.landingPro}
          href={isAuthenticated ? `${urlEnum.profile}/[prefType]` : urlEnum.landingPro}
          textProps={{ i18nKey: isAuthenticated ? 'common.footer.manage-profile' : 'common.footer.subscribe' }}
        />
      </div>
      <div>
        <BasicLink {...getTransversalLinkProps(urlEnum.faq)} textProps={{ i18nKey: 'common.transversal.faq.title' }} />
      </div>
      <div>
        <BasicLink
          href={isAuthenticated ? urlEnum.landingPro : urlEnum.signUp}
          textProps={{ i18nKey: isAuthenticated ? 'common.footer.discover-pro' : 'common.footer.become-member' }}
        />
      </div>
      <div>
        <BasicLink href={urlEnum.partners} textProps={{ i18nKey: 'common.footer.our-partners' }} />
      </div>
      <div>
        <BasicLink
          onClick={() => (isAuthenticated ? signOut(undefined) : showSignInModal())}
          textProps={{ i18nKey: isAuthenticated ? 'auth.disconnect' : 'common.footer.sign-in' }}
        />
      </div>
      <div>
        <BasicLink {...getTransversalLinkProps(urlEnum.legalNotice)} textProps={{ i18nKey: 'common.footer.about' }} />
      </div>
      <div>
        <BasicLink href={urlEnum.espaceAssurance} textProps={{ i18nKey: 'common.transversal.espaceAssurance.title' }} />
      </div>
      <div>
        <BasicLink
          textProps={{ i18nKey: 'common.footer.landing-app' }}
          {...getTransversalLinkProps(urlEnum.landingPage)}
        />
      </div>
      <div>
        <BasicLink
          {...getTransversalLinkProps(urlEnum.signUpStudentOffer)}
          textProps={{ i18nKey: 'common.footer.student-offer' }}
        />
      </div>
    </div>
  );
};

export default QuickAccess;
